<template>
  <BaseLoading  opaque :spinning="athleteLoading">
    <div>
      <div class="container general-form-wrap">
        <div class=" heading">
          <h2 class="form-title">Chat Settings</h2>
        </div>
        <div class="upload-container checkbox-container-wrapper">
          <a-row>
            <a-col :sm="12">
              <a-checkbox v-model="blockCollegeCoaches">
                Block messages from College Coaches
              </a-checkbox>
              <Tooltip>
                <template slot="title">
                  <span
                    >This will block college coaches from connecting and
                    messaging you.</span
                  >
                </template>
                <BaseIcon type="info-circle" />
              </Tooltip>
            </a-col>
            <a-col :sm="12">
              <a-checkbox v-model="blockClubCoaches">
                Block messages from Club Coaches
              </a-checkbox>
              <Tooltip>
                <template slot="title">
                  <span
                    >This will block club coaches from connecting and messaging
                    you.</span
                  >
                </template>
                <BaseIcon type="info-circle" />
              </Tooltip>
            </a-col>
          </a-row>
          <a-row>
            <a-col>
              <a-button
                type="primary margin-t-1"
                @click="toggleModal('showConfirmModal')"
              >
                Apply
              </a-button>
            </a-col>
          </a-row>
          <BaseModal
            :visible="showConfirmModal"
            :ok-button-props="{ class: 'danger-button' }"
            title="Are you sure?"
            ok-text="Confirm"
            ok-type="danger"
            @cancel="toggleModal('showConfirmModal')"
            @ok="handleApplyButton"
          >
            <p slot="content">
              {{ confirmMessage }}
            </p>
          </BaseModal>
        </div>
      </div>
    </div>
  </BaseLoading>
</template>

<script>
import { Athlete } from "@/models";
const ATHLETE_STORE_KEY = "athleteStore";
import { mapGetters } from "vuex";
import { Tooltip } from "ant-design-vue";

export default {
  components: {
    Tooltip
  },
  data() {
    return {
      blockCollegeCoaches: false,
      blockClubCoaches: false,
      showConfirmModal: false
    };
  },
  computed: {
    profileId() {
      return Athlete.profileId();
    },
    ...mapGetters({
      athlete: `${ATHLETE_STORE_KEY}/athlete`,
      athleteLoading: `${ATHLETE_STORE_KEY}/athleteLoading`
    }),
    blockgroups() {
      let groupsToBlock = "";
      if (this.blockCollegeCoaches) groupsToBlock = "college coaches";
      if (this.blockClubCoaches && this.blockCollegeCoaches)
        groupsToBlock = "college coaches and club coaches";
      if (this.blockClubCoaches && !this.blockCollegeCoaches)
        groupsToBlock = "club coaches";
      return groupsToBlock;
    },
    confirmMessage() {
      if (this.blockClubCoaches || this.blockCollegeCoaches)
        return `New ${this.blockgroups} will no longer be able to search for you or connect with you. If you previously connected with ${this.blockgroups}, 
        they can still message you. In order to stop all communication,
         you may block them one by one from your chat screen.`;
      return "All blocked groups will be unblocked.";
    }
  },
  async mounted() {
    await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthlete`, {
      id: this.profileId
    });
  },
  methods: {
    async handleApplyButton() {
      await this.$store.dispatch(`${ATHLETE_STORE_KEY}/updateBlockedGroup`, {
        id: this.profileId,
        blockedGroup: [
          this.blockClubCoaches ? "clubCoach" : "",
          this.blockCollegeCoaches ? "collegeCoach" : ""
        ].filter(group => group)
      });
      this.showConfirmModal = false;
    },
    toggleModal() {
      this.showConfirmModal = !this.showConfirmModal;
    }
  },
  watch: {
    athlete(newVal) {
      if (newVal.blockedGroup.includes("clubCoach"))
        this.blockClubCoaches = true;
      if (newVal.blockedGroup.includes("collegeCoach"))
        this.blockCollegeCoaches = true;
    }
  }
};
</script>

<style lang="sass" scoped>
.checkbox-container-wrapper
  margin: 2rem
.form-title
  position: relative;
  margin: 2rem !important
  &::before
    content: ""
    position: absolute
    right: 56%
    width: 4px
    height: 100%
    background: #d23129
</style>
